import { z } from 'zod';

/** Сколько ждём согласия друга и сколько живёт его селфи. */
export const DUO_INVITE_TTL_HOURS = 24;
export const DUO_PHOTO_TTL_HOURS = 24;
export const DUO_PREFIX = 'd_';
const DUO_CODE_RE = /^d_([a-z0-9]{10})$/;

export function parseDuoStart(param: string | null | undefined): string | null {
  const m = DUO_CODE_RE.exec(param ?? '');
  return m ? m[1]! : null;
}

export const createDuoRequestSchema = z.object({
  trendId: z.string().uuid(),
  photoIds: z.array(z.string().uuid()).max(4).default([]),
  useTwin: z.boolean().default(false),
  fields: z.record(z.string().max(20), z.string().max(300)).default({}),
});
export type CreateDuoRequest = z.input<typeof createDuoRequestSchema>;

export const DUO_STATUS_LIST = ['pending', 'accepted', 'declined', 'expired', 'canceled'] as const;

/** Приглашение глазами пригласившего (DuoInvite) и друга (DuoConfirm). */
export const duoInviteSchema = z.object({
  code: z.string(),
  status: z.enum(DUO_STATUS_LIST),
  /** Я пригласил (true) или меня позвали. */
  mine: z.boolean(),
  inviterName: z.string(),
  friendName: z.string().nullable(),
  trend: z.object({ id: z.string().uuid(), title: z.string(), coverUrl: z.string().nullable(), coverGradient: z.string(), frames: z.number().int(), output: z.string() }),
  price: z.number().int(),
  /** Ссылки для «Отправить в Telegram». */
  link: z.string().nullable(),
  shareText: z.string(),
  expiresAt: z.string(),
  generationId: z.string().uuid().nullable(),
  /** Другу: есть бесплатная своя генерация (новенький). */
  friendFreeGeneration: z.boolean(),
  balance: z.number().int(),
});
export type DuoInvite = z.infer<typeof duoInviteSchema>;

/** Эмодзи стикера из подписи («😂 Смех» → 😂). Нет эмодзи — 🙂. */
export function stickerEmoji(label: string | null | undefined): string {
  const m = /\p{Extended_Pictographic}(?:️|‍\p{Extended_Pictographic})*/u.exec(label ?? '');
  return m ? m[0] : '🙂';
}
